let language = {
    SELECT_STORE_TITLE: "选择店铺",
    SELECT_STORE_CREATE_STORE_TIP: "去创建店铺",
};

export { language }
